import { useMutation } from 'react-query';
import { getParentStages } from '../index';
export const useGetParentStages = () => useMutation(getParentStages);
